import { render, staticRenderFns } from "./flat_buttons.vue?vue&type=template&id=ae11255e&"
import script from "./flat_buttons.vue?vue&type=script&lang=js&"
export * from "./flat_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports